import { render, staticRenderFns } from "./VehicleContractDocumentsWidget.vue?vue&type=template&id=0bfdf98e&scoped=true&"
import script from "./VehicleContractDocumentsWidget.vue?vue&type=script&lang=js&"
export * from "./VehicleContractDocumentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./VehicleContractDocumentsWidget.vue?vue&type=style&index=0&id=0bfdf98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfdf98e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bfdf98e')) {
      api.createRecord('0bfdf98e', component.options)
    } else {
      api.reload('0bfdf98e', component.options)
    }
    module.hot.accept("./VehicleContractDocumentsWidget.vue?vue&type=template&id=0bfdf98e&scoped=true&", function () {
      api.rerender('0bfdf98e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleContractDocumentsWidget.vue"
export default component.exports